/** Server response for /notification/{auth|no-auth}/:notificationId */
export let NotificationType;

(function (NotificationType) {
  NotificationType["Relationship"] = "relationship";
  NotificationType["Invoice"] = "invoice";
  NotificationType["Account"] = "account";
  NotificationType["Business"] = "business";
})(NotificationType || (NotificationType = {}));

export let BusinessNotificationType;

(function (BusinessNotificationType) {
  BusinessNotificationType["ReminderConnectKyc"] = "ReminderConnectKyc";
  BusinessNotificationType["PayoutReconciliation"] = "payoutReconciliation";
  BusinessNotificationType["PaymentsDigest"] = "PaymentsDigest";
  BusinessNotificationType["AccountantJoinRequest"] = "AccountantJoinRequest";
  BusinessNotificationType["AccountantJoinRequestApproved"] = "AccountantJoinRequestApproved";
  BusinessNotificationType["AccountantJoinRequestRejected"] = "AccountantJoinRequestRejected";
  BusinessNotificationType["AccountantPmAdded"] = "AccountantPmAdded";
  BusinessNotificationType["ReferredVendorCreditsAwarded"] = "ReferredVendorCreditsAwarded";
  BusinessNotificationType["ReferringVendorCreditsAwarded"] = "ReferringVendorCreditsAwarded";
  BusinessNotificationType["PayoutDepositedVendor"] = "PayoutDepositedVendor";
  BusinessNotificationType["PayoutFailedVendor"] = "PayoutFailedVendor";
  BusinessNotificationType["PayoutDepositedRetryVendor"] = "PayoutDepositedRetryVendor";
  BusinessNotificationType["ManualMicroDepositInitiatedCustomer"] = "ManualMicroDepositInitiatedCustomer";
  BusinessNotificationType["ManualMicroDepositInitiatedVendor"] = "ManualMicroDepositInitiatedVendor";
})(BusinessNotificationType || (BusinessNotificationType = {}));

export let AccountNotificationType;

(function (AccountNotificationType) {
  AccountNotificationType["EmailVerification"] = "emailVerification";
  AccountNotificationType["EmailUpdate"] = "emailUpdate";
  AccountNotificationType["OneTimeAccess"] = "oneTimeAccess";
  AccountNotificationType["ResetPasswordRequested"] = "resetPasswordRequested";
  AccountNotificationType["InviteToJoinBusiness"] = "inviteToJoinBusiness";
  AccountNotificationType["VerificationPassed"] = "verificationPassed";
  AccountNotificationType["ContinueVendorOnboarding"] = "ContinueVendorOnboarding";
  AccountNotificationType["PasswordResetSuccessfully"] = "passwordResetSuccessfully";
})(AccountNotificationType || (AccountNotificationType = {}));

export let InvoiceNotificationType;

(function (InvoiceNotificationType) {
  InvoiceNotificationType["InvoiceIssuedOLD"] = "invoiceIssued";
  InvoiceNotificationType["InvoiceIssued"] = "InvoiceIssued";
  InvoiceNotificationType["InvoiceIssuedForPayment"] = "invoiceIssuedForPayment";
  InvoiceNotificationType["InvoiceIssuedRequiresApproval"] = "invoiceIssuedRequiresApproval";
  InvoiceNotificationType["PaidCustomer"] = "paidCustomer";
  InvoiceNotificationType["PaymentFailed"] = "paymentFailed";
  InvoiceNotificationType["PaymentProcessingCustomer"] = "paymentProcessingCustomer";
  InvoiceNotificationType["PaymentProcessingVendor"] = "paymentProcessingVendor";
  InvoiceNotificationType["UpcomingForImmediatePayment"] = "upcomingForImmediatePayment";
  InvoiceNotificationType["ExtensionRequested"] = "extensionRequested";
  InvoiceNotificationType["OneOffIssuedRequiresApproval"] = "oneOffIssuedRequiresApproval";
  InvoiceNotificationType["InvoiceApproved"] = "InvoiceApproved";
  InvoiceNotificationType["ProcessingActionPending"] = "processingActionPending";
  InvoiceNotificationType["InvoiceRefundedVendor"] = "InvoiceRefundedVendor";
  InvoiceNotificationType["InvoiceRefundedCustomer"] = "InvoiceRefundedCustomer";
  InvoiceNotificationType["InvoicePaymentStoppedCustomer"] = "InvoicePaymentStoppedCustomer";
  InvoiceNotificationType["InvoicePaymentStoppedVendor"] = "InvoicePaymentStoppedVendor";
  InvoiceNotificationType["InvoicePaymentResumedVendor"] = "InvoicePaymentResumedVendor";
  InvoiceNotificationType["InvoicePaymentResumedCustomer"] = "InvoicePaymentResumedCustomer";
  InvoiceNotificationType["PaymentDisputedVendor"] = "PaymentDisputedVendor";
})(InvoiceNotificationType || (InvoiceNotificationType = {}));

export let RelationshipNotificationType;

(function (RelationshipNotificationType) {
  RelationshipNotificationType["Added"] = "added";
  RelationshipNotificationType["AddedWithCustomText"] = "addedWithCustomText";
  RelationshipNotificationType["AdHocChargeAdded"] = "adHocChargeAdded";
  RelationshipNotificationType["AdHocChargeCanceled"] = "adHocChargeCanceled";
  RelationshipNotificationType["AdHocChargeApprovalReminder"] = "adHocChargeApprovalReminder";
  RelationshipNotificationType["AgreementAmendmentsReminder"] = "agreementAmendmentsReminder";
  RelationshipNotificationType["AgreementApprovalReminder"] = "agreementApprovalReminder";
  RelationshipNotificationType["AgreementApprovalReminderManual"] = "agreementApprovalReminderManual";
  RelationshipNotificationType["Amended"] = "amended";
  RelationshipNotificationType["AmendedNoClientApproval"] = "amendedNoClientApproval";
  RelationshipNotificationType["Approved"] = "approved";
  RelationshipNotificationType["ApprovedAmendments"] = "approvedAmendments";
  RelationshipNotificationType["ClientApprovedRelationship"] = "ClientApprovedRelationship";
  RelationshipNotificationType["ClientUnresponsiveAmendmentsApproval"] = "clientUnresponsiveAmendmentsApproval";
  RelationshipNotificationType["ClientUnresponsivePaymentMethod"] = "clientUnresponsivePaymentMethod";
  RelationshipNotificationType["ClientUnresponsiveSigning"] = "clientUnresponsiveSigning";
  RelationshipNotificationType["CreditApplied"] = "creditApplied";
  RelationshipNotificationType["ExistingCustomer"] = "existingCustomer";
  RelationshipNotificationType["ExistingCustomerWithText"] = "existingCustomerWithText";
  RelationshipNotificationType["RelationshipDirectLink"] = "RelationshipDirectLink";
  RelationshipNotificationType["MicroDepositCompletionReminder"] = "microDepositCompletionReminder";
  RelationshipNotificationType["MicroDepositProcessInitiated"] = "microDepositProcessInitiated";
  RelationshipNotificationType["New"] = "new";
  RelationshipNotificationType["NewWithText"] = "newWithText";
  RelationshipNotificationType["RelationshipApproveDelivery"] = "RelationshipApproveDelivery";
  RelationshipNotificationType["RelationshipSigning"] = "RelationshipSigning";
  RelationshipNotificationType["SingleUseApproval"] = "singleUseApproval";
  RelationshipNotificationType["Terminated"] = "terminated";
  RelationshipNotificationType["RelationshipApproveDeliveryReminder"] = "RelationshipApproveDeliveryReminder";
  RelationshipNotificationType["RelationshipApproveDeliveryUnresponsive"] = "RelationshipApproveDeliveryUnresponsive";
  RelationshipNotificationType["RelationshipUpdated"] = "RelationshipUpdated";
  RelationshipNotificationType["RelationshipUpdatedWithChanges"] = "RelationshipUpdatedWithChanges";
  RelationshipNotificationType["AmendmentsAutoApprovalReminder"] = "AmendmentsAutoApprovalReminder";
  RelationshipNotificationType["RequestPaymentMethod"] = "RequestPaymentMethod";
  RelationshipNotificationType["AmendmentsAutoApproved"] = "AmendmentsAutoApproved";
})(RelationshipNotificationType || (RelationshipNotificationType = {}));